import React, { useEffect, useState } from 'react';
import { Col, Row, Button } from 'react-bootstrap';

const CardSuccess = ({ getValues, fullName }) => {
  const [counter, setCounter] = useState(30);
  const [int, setInt] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter((counter) => counter - 1);
    }, 1000);
    setInt(interval);

    return () => clearInterval(int);
  }, []);

  useEffect(() => {
    if (counter === 0) {
      clearInterval(int);
      redirect();
    }
  }, [counter]);

  const redirect = () => {};

  return (
    <div className='card-success'>
      <header>
        <i className='la la-thumbs-up great' />
        <h4>Compra Realizada</h4>
      </header>
      <p>
        {fullName.split(' ')[0]}, parabéns! Sua compra foi realizada com
        sucesso, <b>não feche esta página.</b>
      </p>
      {/* <p>
        Você acaba de receber um e-mail com o resumo da sua transação. Caso não
        o encontre, certifique-se de olhar a sua pasta de lixo eletrônico ou de
        spam.
      </p> */}
      <div className='redirecting'>
        <i className='la la-circle-notch la-spin mr-2' />
        <span>Redirecionando...</span>
      </div>
    </div>
  );
};

export default CardSuccess;
